<template>
  <Layout>
    <div class="modal-backdrop" @click="redirectToMarketplace">
      <div class="modal-container" @click.stop>
        <canvas ref="confettiCanvas" class="confetti-canvas"></canvas>

        <div class="success-modal">
          <div class="success-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="#10B981"/>
              <path d="M25 40L35 50L55 30" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="success-content">
            <h2 class="success-title">{{$t('sent_to_approve')}}</h2>
            <p class="success-description">
              {{$t('product_creation_successful')}}<br>
              {{$t('product_creation_successful_2')}}
            </p>
          </div>

          <button @click="redirectToMarketplace" class="success-button">
            {{$t('go_to_my_products')}}
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
  name: 'MarketplaceSuccess',
  components: {
    Layout
  },
  mounted() {
    this.$nextTick(() => {
      this.initConfetti();
      this.startConfetti();
    });
  },
  beforeUnmount() {
    if (this.confettiInterval) {
      clearInterval(this.confettiInterval);
    }
  },
  methods: {
    redirectToMarketplace() {
      this.$router.push('/marketplace');
    },

    initConfetti() {
      const canvas = this.$refs.confettiCanvas;
      const ctx = canvas.getContext('2d');

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      this.canvas = canvas;
      this.ctx = ctx;
      this.confettiPieces = [];

      for (let i = 0; i < 100; i++) {
        this.confettiPieces.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height - canvas.height,
          width: Math.random() * 20 + 10,
          height: Math.random() * 20 + 10,
          color: this.getRandomColor(),
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 10,
          velocityX: (Math.random() - 0.5) * 3,
          velocityY: Math.random() * 3 + 2,
          gravity: 0.1
        });
      }
    },

    getRandomColor() {
      const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
        '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
        '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },

    updateConfetti() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.confettiPieces.forEach(piece => {
        piece.x += piece.velocityX;
        piece.y += piece.velocityY;
        piece.velocityY += piece.gravity;
        piece.rotation += piece.rotationSpeed;

        // Reset piece when it goes off screen
        if (piece.y > this.canvas.height) {
          piece.y = -piece.height;
          piece.x = Math.random() * this.canvas.width;
          piece.velocityY = Math.random() * 3 + 2;
        }

        this.ctx.save();
        this.ctx.translate(piece.x + piece.width / 2, piece.y + piece.height / 2);
        this.ctx.rotate(piece.rotation * Math.PI / 180);
        this.ctx.fillStyle = piece.color;
        this.ctx.fillRect(-piece.width / 2, -piece.height / 2, piece.width, piece.height);
        this.ctx.restore();
      });
    },

    startConfetti() {
      this.confettiInterval = setInterval(() => {
        this.updateConfetti();
      }, 16);

      setTimeout(() => {
        if (this.confettiInterval) {
          clearInterval(this.confettiInterval);
        }
      }, 5000);
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.success-modal {
  background: white;
  border-radius: 24px;
  padding: 48px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  width: 90%;
  position: relative;
  z-index: 2;
  animation: modalSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.success-icon {
  margin-bottom: 32px;
  animation: iconBounce 1s ease-out 0.3s both;
}

@keyframes iconBounce {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.success-content {
  margin-bottom: 40px;
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #040C2D;
  margin-bottom: 16px;
  font-family: 'euclid_medium', sans-serif;
  animation: textSlideIn 0.8s ease-out 0.6s both;
}

.success-description {
  font-size: 16px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0;
  font-family: 'euclid_medium', sans-serif;
  animation: textSlideIn 0.8s ease-out 0.8s both;
}

@keyframes textSlideIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-button {
  background: #040C2D;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'euclid_medium', sans-serif;
  animation: buttonSlideIn 0.8s ease-out 1s both;
  min-width: 160px;
}

.success-button:hover {
  background: #0D1A47;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(4, 12, 45, 0.3);
}

@keyframes buttonSlideIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .success-modal {
    padding: 32px 24px;
    margin: 20px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-description {
    font-size: 14px;
  }
}
</style>
